import _ from 'lodash';

import { valueToDisplay } from '../../libs/products';
import { getLegs as getDeliveryLegs, fuelToPickupField } from '../../libs/deliveryLegs';
//import React from "react";
//import {Fragment} from "react";

export const NET_GALLONS_DELIVERY_MATCH_THRESHOLD = 0.05;
export const MIN_GALLONS_FOR_BULK_WARNING = 7900;
export const MAX_GALLONS_FOR_BULK_WARNING = 8200;
export const INTERNAL_TERMINAL_ID = 25;

export const documentTypeSort = {
	//- station and bulk delivery
	carrierDeliveryTicket: 100,
	carrierShippingOrder: 150,
	stationDeliveryPickupBol: 200,
	//pickupEtohBol : 220,
	//offloadEtohBol : 240,
	veederReceipt: 400,
	misc: 500,
	other: 600,
	ignore: 700,
};

export const getDocuments = (p) => {
	const {
		stationDelivery,
		bulkDelivery,
		carrierMap,
		terminalMap,
		supplierMap,
		invoiceDocuments,
		isRackTransfer,
	} = p;

	let requiredDocuments = [];
	if (stationDelivery) {
		const {
			isDualFuelPickup,
			carrierId,
			firstTerminalTerminalId,
			firstTerminalProductType,
			secondTerminalTerminalId,
			secondTerminalProductType,
		} = stationDelivery;

		const carrier = carrierMap[carrierId] || { name: `Missing carrier: ${carrierId}` };

		const firstTerminalTerminal = terminalMap[firstTerminalTerminalId] || {
			name: `Missing firstTerminal terminal: ${firstTerminalTerminalId}`,
		};

		let secondTerminalTerminal;
		if (isDualFuelPickup) {
			secondTerminalTerminal = terminalMap[secondTerminalTerminalId] || {
				name: `Missing secondTerminal terminal: ${secondTerminalTerminalId}`,
			};
		}

		const firstTerminalProductDisplay = valueToDisplay(firstTerminalProductType);
		const secondTerminalProductDisplay = valueToDisplay(secondTerminalProductType);

		requiredDocuments = [
			{
				documentType: 'carrierDeliveryTicket',
				name: `${carrier.name} Delivery Ticket`,
				isRequired: true,
			},
			{
				documentType: 'stationDeliveryPickupBol',
				productType: firstTerminalProductType,
				name: `${firstTerminalTerminal.name} ${firstTerminalProductDisplay} BOL`,
				isRequired: true,
			},
		];

		if (secondTerminalTerminal) {
			requiredDocuments.push({
				documentType: 'stationDeliveryPickupBol',
				productType: secondTerminalProductType,
				name: `${secondTerminalTerminal.name} ${secondTerminalProductDisplay} BOL`,
				isRequired: true,
			});
		}
	} else if (bulkDelivery) {
		const { carrierId, pickupTerminalId, deliveryTerminalId, productType } = bulkDelivery;

		const carrier = carrierMap[carrierId] || { name: `Missing carrier: ${carrierId}` };

		const pickTerminal = terminalMap[pickupTerminalId] || {
			name: `Missing pickup terminal: ${pickupTerminalId}`,
		};

		const offloadTerminal = terminalMap[deliveryTerminalId] || {
			name: `Missing offload terminal: ${deliveryTerminalId}`,
		};

		//- XXX assumes e85 right now
		requiredDocuments = [];

		//- PICKUPS from internal are just tank transfers so there won't be a carrier ticket
		if (pickupTerminalId !== INTERNAL_TERMINAL_ID) {
			requiredDocuments.push({
				documentType: 'carrierDeliveryTicket',
				name: `${carrier.name} Delivery Ticket`,
				isRequired: true,
			});
		}

		if (isRackTransfer) {
			requiredDocuments.push(
				{
					documentType: 'pickupBol',
					productType,
					name: `${pickTerminal.name} Pickup BOL`,
					isRequired: true,
				},
				{
					documentType: 'offloadBol',
					productType,
					name: `${offloadTerminal.name} Offload BOL`,
					isRequired: false,
				}
			);
		} else {
			requiredDocuments.push(
				{
					documentType: 'pickupBol',
					productType,
					name: `${pickTerminal.name} Pickup BOL`,
					isRequired: true,
				},
				{
					documentType: 'offloadBol',
					productType,
					name: `${offloadTerminal.name} Offload BOL`,
					isRequired: true,
				}
			);
		}
	} else {
		requiredDocuments = [
			{
				documentType: 'missing',
				name: `Missing station and/or bulk delivery. Contact support`,
				isRequired: true,
			},
		];
	}

	//- Get the current delivery documents and the missing required documents
	let uploadedInvoiceDocuments = invoiceDocuments;
	let missingInvoiceDocuments = [];

	const requiredMap = _.groupBy(requiredDocuments, (invoiceDocument) => {
		const { documentType, productType } = invoiceDocument;
		if (productType) {
			return `${documentType}_${productType}`;
		} else {
			return documentType;
		}
	});

	//- Pick off the required ones we already have

	invoiceDocuments.forEach((invoiceDocument) => {
		const { documentType, data } = invoiceDocument;
		const productType = _.get(data, 'productType');

		const key = productType ? `${documentType}_${productType}` : documentType;

		//- Got a match. Tick one off
		if (!_.isEmpty(requiredMap[key])) {
			requiredMap[key].pop();
			if (_.isEmpty(requiredMap[key])) {
				delete requiredMap[key];
			}
		}

		//- Also calc the title and details
		if (documentType === 'carrierDeliveryTicket') {
			const { carrierId, carrierPoNumber } = invoiceDocument.data;
			const carrier = carrierMap[carrierId] || { name: `MISSING CARRIER: ${carrierId}` };
			invoiceDocument.name = `${carrier.name} Delivery Ticket`;
			invoiceDocument.details = `PO Number : ${carrierPoNumber}`;

			//- Also calc the title and details
		} else if (documentType === 'carrierShippingOrder') {
			const { carrierId } = invoiceDocument.data;
			const carrier = carrierMap[carrierId] || { name: `MISSING CARRIER: ${carrierId}` };
			invoiceDocument.name = `${carrier.name} Shipping Order`;
		} else if (
			documentType === 'stationDeliveryPickupBol' ||
			documentType === 'pickupBol' ||
			documentType === 'offloadBol'
		) {
			const productDisplay = valueToDisplay(productType);

			//- offloading doesn't have supplier it has a customer
			if (documentType === 'offloadBol') {
				const { terminalId, netGallons } = invoiceDocument.data;

				const terminal = terminalMap[terminalId] || { name: `Missing Terminal: ${terminalId}` };

				invoiceDocument.name = `${terminal.name} ${productDisplay} BOL`;
				invoiceDocument.details = `${netGallons} ${productDisplay}`;
			} else {
				const { terminalSupplier, netGallons } = invoiceDocument.data;
				const { terminalId, supplierId } = terminalSupplier || {};

				const terminal = terminalMap[terminalId] || { name: `Missing Terminal: ${terminalId}` };

				const supplier = supplierMap[supplierId] || { name: `Missing supplier: ${supplierId}` };

				invoiceDocument.name = `${terminal.name} ${productDisplay} BOL`;
				invoiceDocument.details = `${netGallons} ${productDisplay} from ${supplier.name}`;
			}
		} else if (documentType === 'veederReceipt') {
			invoiceDocument.name = `Veeder Receipt`;
			invoiceDocument.details = '';
		} else {
			const { documentName } = invoiceDocument.data;
			invoiceDocument.name = documentName || `${_.capitalize(documentType)}`;
		}
	});

	_.values(requiredMap).forEach((array) => {
		missingInvoiceDocuments = _.compact(missingInvoiceDocuments.concat(array));
	});

	missingInvoiceDocuments = _.orderBy(
		missingInvoiceDocuments,
		({ documentType, name }) => {
			if (!documentType) {
				return 99;
			}
			return (documentTypeSort[documentType] || 98) + '_' + name;
		},
		'asc'
	);

	uploadedInvoiceDocuments = _.orderBy(
		uploadedInvoiceDocuments,
		({ documentType, name }) => {
			if (!documentType) {
				return 99;
			}
			return (documentTypeSort[documentType] || 98) + '_' + name;
		},
		'asc'
	);

	return { uploadedInvoiceDocuments, missingInvoiceDocuments };
};

export const matchProductToDelivery = (p) => {
	const {
		stationDeliveryMap,
		stationInvoice,
		productType,
		netGallons,

		//not always in
		terminalId,
		supplierId,
		terminalMap,
		supplierMap,
	} = p;

	if (!stationInvoice) {
		return { skip: 'no station invoice' };
	}

	//- If this is an update and has a delivery, then check it
	const { linkedStationDeliveryId } = stationInvoice;
	if (!linkedStationDeliveryId) {
		return { skip: 'no linkedDeliveryId ' };
	}

	const stationDelivery = stationDeliveryMap[linkedStationDeliveryId];
	if (!stationDelivery) {
		return { skip: 'no stationDelivery' };
	}

	const {
		firstTerminalProductType,
		firstTerminalTerminalId,
		firstTerminalSupplierId,

		secondTerminalProductType,
		secondTerminalTerminalId,
		secondTerminalSupplierId,
	} = stationDelivery;

	const { stationId } = stationInvoice;
	if (!stationId) {
		return { skip: 'no stationId' };
	}

	const ret = {
		reasonsForNotMatching: [],
		matched: null,
	};

	//
	//- Figure out what fuel (terminal side) we are talking about
	//
	let terminalPrefix;
	let deliveryTerminalId;
	let deliverySupplierId;

	if (firstTerminalProductType === productType) {
		terminalPrefix = 'firstTerminal';
		deliveryTerminalId = firstTerminalTerminalId;
		deliverySupplierId = firstTerminalSupplierId;
	} else if (secondTerminalProductType === productType) {
		terminalPrefix = 'secondTerminal';
		deliveryTerminalId = secondTerminalTerminalId;
		deliverySupplierId = secondTerminalSupplierId;
	} else {
		ret.reasonsForNotMatching.push(
			`${productType} not found on delivery. ` +
				`Found : ${firstTerminalProductType} and ${secondTerminalProductType}`
		);
		return ret;
	}

	//- Sum the invoice station's stops (two tanks at one station is one amount)
	const legs = getDeliveryLegs(stationDelivery);
	const stationLegs = legs.filter((leg) => leg.stationId === stationId);
	if (!stationLegs.length) {
		ret.reasonsForNotMatching.push(`StationId:${stationId} does not match any stop on delivery`);
		return ret;
	}

	const amount = stationLegs.reduce((sum, leg) => {
		const legAmount = stationDelivery[fuelToPickupField(terminalPrefix, leg.legNumber)];
		return sum + (legAmount || 0);
	}, 0);

	if (amount === 0) {
		ret.reasonsForNotMatching.push(`Fuel type (${productType}) amount is zero.`);
		return ret;
	}

	const threshold = NET_GALLONS_DELIVERY_MATCH_THRESHOLD;
	const margin = _.round(amount * threshold);
	const min = amount - margin;
	const max = amount + margin;
	const expectedLine = `between ${min} and ${max}`;

	if (netGallons >= min && netGallons <= max) {
		ret.matched = { amount, min, max };
	} else {
		ret.reasonsForNotMatching.push(
			`Net gallons do not match delivery amount within ${threshold * 100}%.`,
			`Expect net gallons ${expectedLine}`
		);
	}
	ret.expectedLine = `Based on delivery expect net gallons ${expectedLine}`;

	const productDisplay = valueToDisplay(productType);
	if (terminalId) {
		if (deliveryTerminalId !== terminalId) {
			const deliveryTerminal = terminalMap[deliveryTerminalId] || { name: 'Missing' };
			const invoiceTerminal = terminalMap[terminalId] || { name: 'Missing' };
			ret.reasonForTerminalNotMatching =
				`${_.upperFirst(productDisplay)} delivery terminal (${deliveryTerminal.name}) ` +
				`does not match invoiced terminal (${invoiceTerminal.name}).`;
		} else {
			ret.terminalsMatch = true;
		}
	}

	if (supplierId) {
		if (deliverySupplierId !== supplierId) {
			const deliverySupplier = supplierMap[deliverySupplierId] || { name: 'Missing' };
			const invoiceSupplier = supplierMap[supplierId] || { name: 'Missing' };

			ret.reasonForSupplierNotMatching =
				`${_.upperFirst(productDisplay)} delivery supplier (${deliverySupplier.name}) ` +
				`does not match invoiced supplier (${invoiceSupplier.name}).`;
		} else {
			ret.suppliersMatch = true;
		}
	}

	return ret;
};

export const matchProductToBulkDelivery = (p) => {
	const { bulkInvoice, rackTransfer, netGallons } = p;
	if (!bulkInvoice && !rackTransfer) {
		return { skip: 'no bulk invoice' };
	}

	const ret = {
		reasonsForNotMatching: [],
		matched: null,
	};

	const min = MIN_GALLONS_FOR_BULK_WARNING;
	const max = MAX_GALLONS_FOR_BULK_WARNING;
	const expectedLine = `between ${min} and ${max}`;

	if (netGallons >= min && netGallons <= max) {
		ret.matched = { netGallons, min, max };
	} else {
		ret.reasonsForNotMatching.push(
			`Net gallons outside normal delivery amounts.`,
			`Expect net gallons ${expectedLine}.`
		);
	}
	ret.expectedLine = `Based on delivery expect net gallons ${expectedLine}`;

	return ret;
};

//- Used in StationInvoices and invoiceSearhc

export const invoiceStatusClassNames = {
	pending: {
		fontWeight: 900,
		color: '#2196F3',
	},
	error: {
		fontWeight: 900,
		color: '#FF500F',
	},
	sent: {
		fontWeight: 900,
		color: '#FF500F',
	},
	cancelled: {
		fontWeight: 900,
		color: '#FF500F',
	},
	invalid: {
		fontWeight: 900,
		color: '#FF500F',
	},
	pendingVeryOld: {
		fontWeight: 900,
		color: '#FF500F',
	},
	pendingOld: {
		fontWeight: 900,
		color: '#FF9800',
	},
	normal: {
		color: '#616161',
		fontWeight: 900,
	},
	issued: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	paid: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	credited: {
		fontWeight: 900,
		color: '#9C27B0',
	},
};

export const statusToDisplay = {
	pending: 'Pending',
	issued: 'Issued',
	invalid: 'Invalid',
	sent: 'Sent - !NOT ISSUED!',
	credited: 'Credited',
};

// Create our number formatter.
export const moneyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
	// the default value for minimumFractionDigits depends on the currency
	// and is usually already 2
});
